import React, { useState } from "react";
import { SelectButton } from "primereact/selectbutton";
import sizeNeakless from "../images/size-neakless.svg";

function SizeReview() {
    const [value, setValue] = useState(1);
    const items = [
        { name: "Кільця", value: 1 },
        { name: "Ланцюжки", value: 2 },
        { name: "Браслети", value: 3 },
    ];

    return (
        <>
            <h2 className="font-bold text-3xl mb-5">Визначити розмір</h2>

            <SelectButton
                className="border-2 rounded-lg focus:shadow-none mb-4 w-full flex justify-center items-center size-select"
                value={value}
                onChange={(e) => setValue(e.value)}
                optionLabel="name"
                options={items}
            />

            {value === 1 ? (
                <div>
                    <div class="size-table">
                        <div class="flex justify-between">
                            <div class="">Розмір</div>
                            <div class="">Окружність пальця, мм</div>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>15</span>
                            <span>47-48мм</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>15.5</span>
                            <span>48-49мм</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>16</span>
                            <span>49-50мм</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>16.5</span>
                            <span>50-52мм</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>17</span>
                            <span>52-53мм</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>17,5</span>
                            <span>53-55мм</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>18</span>
                            <span>55-56мм</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>18.5</span>
                            <span>56-58мм</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>19</span>
                            <span>58-59мм</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>19.5</span>
                            <span>59-61мм</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>20</span>
                            <span>62-63мм</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>20,5</span>
                            <span>63-65мм</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>21</span>
                            <span>65-66мм</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>21,5</span>
                            <span>67-68мм</span>
                        </div>
                        <div class="flex justify-between mt-2">
                            <span>22</span>
                            <span>68-69мм</span>
                        </div>
                    </div>
                </div>
            ) : value === 2 ? (
                <div className="flex justify-center items-center">
                    <img src={sizeNeakless} alt="sizes"></img>
                </div>
            ) : (
                <div>
                    <div class="size-table">
                        <div class="flex justify-between text-sm lg:text-base">
                            <div class="">Oбхват зап'ястя (см)</div>
                            <div class="text-center">Рекомендований розмір</div>
                            <div class="text-end">Світове маркування</div>
                        </div>
                        <div class="flex justify-between border-b border-black my-2 ">
                            <span>14-15.5</span>
                            <span>16</span>
                            <span>XS</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>15.5-16</span>
                            <span>17</span>
                            <span>S</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>16-17</span>
                            <span>18мм</span>
                            <span>M</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>17-18</span>
                            <span>19</span>
                            <span>L</span>
                        </div>
                        <div class="flex justify-between border-b border-black my-2">
                            <span>18-19</span>
                            <span>20</span>
                            <span>XS</span>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default SizeReview;
